import React, { useEffect, useState } from "react";
import moment from "moment";
import columns from "../../columns/reports/invoiceReport";
import SkeletonTable from "../../components/table/SkeletonTable";
import { GetInvoiceReportApi } from "../../api/request/report";

const InvoiceReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [invoiceList, setInvoiceList] = useState([]);

  const getInvoiceList = async (page = 1) => {
    try {
      setIsLoading(true);
      const { data } = await GetInvoiceReportApi({ page });
      if (data?.status) {
        setInvoiceList(
          data?.data?.map((item) => {
            return {
              ...item,
              name: item?.user?.name,
              email: item?.user?.email,
              file: (
                <div className="font-bold highlight-text capitalize">
                  {item?.file_name}
                </div>
              ),
              created_at: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "",
              invoice_send_date: item?.invoice_send_date
                ? moment(item?.invoice_send_date).format("lll")
                : "",
              status: (
                <p
                  className={`font-bold uppercase ${
                    item?.status === "paid"
                      ? "text-green-500"
                      : "text-red-500"
                  }`}
                >
                  {item?.status}
                </p>
              ),
              action: (
                <a
                  href={item?.invoice_pdf || "#"}
                  target={item?.invoice_pdf && "_blank"}
                  className="font-medium text-blue-500 underline"
                >
                  View
                </a>
              ),
            };
          })
        );
        setTotal(data?.total_record);
        setCurrentPage(page);
      }
      setIsLoading(false);
    } catch (error) {
      setInvoiceList([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getInvoiceList();
  }, []);

  const handleTableChange = (pagination) => {
    getInvoiceList(pagination?.current);
  };

  return (
    <div className="border rounded-xl bg-white">
      <div class="py-5 px-4 flex items-center justify-between">
        <h2 class="font-semibold text-xl">Invoice {total ? `(${total})` : null}</h2>
      </div>

      <div className="table-radius-0 text-light mb-4">
        <SkeletonTable
          columns={columns}
          data={invoiceList}
          isLoading={isLoading}
          searchingFields={["name", "email", "file_number"]}
          pagination={{
            current: currentPage,
            total: total,
            pageSize: 10,
            showSizeChanger: false,
          }}
          handleTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default InvoiceReport;
